import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';

import styles from './ScrollView.module.scss';

interface IProps {
  horizontal?: boolean;
  useSlipScroll?: boolean;
  className?: string;
  children?: React.ReactNode;
}

class ScrollView extends React.Component<IProps> {
  // Replaces ReactDOM.findDOMNode, which is deprecated in React 18 and removed
  // in 19. The slimScroll branch renders a plain div, so the ref lands on
  // exactly the node findDOMNode used to return.
  private rootRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    if (this.props.useSlipScroll) {
      $(this.rootRef.current).slimScroll({
        height: 'auto',
        position: 'right',
        size: '8px',
        color: '#9ea5ab',
        wheelStep: 5,
        touchScrollStep: 20,
      });
    }
  }

  render() {
    const { horizontal, children, useSlipScroll, className } = this.props;

    if (useSlipScroll) {
      return (
        <div ref={this.rootRef} className={className}>
          {children}
        </div>
      );
    }

    return (
      <div
        ref={this.rootRef}
        className={classNames(styles.root, {
          [styles.horizontal]: horizontal,
        })}
      >
        {children}
      </div>
    );
  }
}

export default ScrollView;
